import axios from 'axios'
import store from "@/store";
import router from "@/router";

export default {
    install(app) {
        axios.defaults.baseURL = location.protocol + process.env.VUE_APP_PUBLIC_PATH;

        if(process.env.VUE_APP_ENV === 'development'){
            if(location.host.indexOf('sprfid') === -1) {
                axios.defaults.baseURL = 'https:' + process.env.VUE_APP_PUBLIC_PATH
            }
        }

        if(process.env.VUE_APP_ENV === 'production'){
            if(location.host.indexOf('sprfid') === -1) {
                axios.defaults.baseURL = 'https:' + process.env.VUE_APP_PUBLIC_PATH
            }
        }

        axios.interceptors.request.use(async function (config) {

            if (config.retry === undefined) {

            }

            config.timeout = 500000;

            if (config.url !== '/user/sign-in/refresh') {
                const token = store.getters['basic/accessToken'];
                if (token !== '') {
                    config.headers.Authorization = "Bearer " + token;
                }
            }

            config.headers["refresh-token"] = store.getters['basic/refreshToken'];
            config.headers["Content-Type"] = "application/json";
            config.headers["Access-Control-Allow-Origin"] = "*";
            config.headers["Access-Control-Allow-Headers"] = "X-Requested-With";

            return config;
        }, function (error) {
            return Promise.reject(error)
        });

        axios.interceptors.response.use(undefined,
            async error => {
                if (error.code === 'ECONNABORTED') {
                    const rtn = {
                        response: {
                            status: 408,
                            data: {
                                code: 0
                            }
                        }
                    }
                    return Promise.reject(rtn)
                }

                const accessToken = store.getters['basic/accessToken']
                const refreshToken = store.getters['basic/refreshToken']
                const userInfo = store.getters['basic/userInfo']

                const er = error.response

                if (er) {

                    const errorData = er.data
                    if (errorData) {
                        const errorBody = errorData.body

                        if (er.status === 401 &&
                            refreshToken !== '' &&
                            accessToken !== '' &&
                            errorBody.error.code.id === 0) {

                            console.log('Token Expired')

                            const errRequest = er.config;
                            errRequest.retry = true

                            await store.dispatch('basic/refreshToken',
                                refreshToken,
                                userInfo.userId).then().catch(e => {
                                if (e.response.status === 401
                                    || e.response.status
                                    === 403 || e.response.status
                                    === 404) { // 리프레시 토큰을 요청 했는데, 해당 요청이 401

                                    // 토큰 정보 및 개인정보를 삭제
                                    removeInfo()

                                    // 로그인 페이지로 이동
                                    router.push({name: "SignIn"})
                                } else {
                                    return Promise.reject(e)
                                }
                            })

                            const retryResult = await axios(errRequest)
                            return retryResult
                        } else {
                            return Promise.reject(error)
                        }

                    } else {
                        return Promise.reject(error)

                    }

                } else {
                    for (const k in error) {
                        console.log(k, error[k])
                    }

                    window.app.config.globalProperties.$error(
                        "exception.response.nobody")
                }

                return Promise.reject(error)
            });

        app.config.globalProperties.axios = axios;
    }
}

function removeInfo() {

    store.dispatch('basic/setAuth', {
        accessToken: '',
        refreshToken: '',
        expired: '',
        userRoles: []
    })
    store.dispatch('basic/initUser');

    window.app.config.globalProperties.$warning("warning.logout.timeout")

}
